import { Link } from "react-router-dom";
import { Seo } from "../components/site/Seo";

export default function NotFound() {
  return (
    <section className="container-lux flex min-h-[60vh] flex-col items-start justify-center py-24" data-testid="not-found">
      <Seo title="Sayfa Bulunamadı | Lunessa Spa Masaj" description="Aradığınız sayfa bulunamadı." path="/404" noindex />
      <span className="eyebrow">404</span>
      <h1 className="mt-4 text-4xl font-bold text-emerald-950 sm:text-5xl">Sayfa bulunamadı</h1>
      <p className="mt-4 text-ink/65">Aradığınız sayfa taşınmış ya da kaldırılmış olabilir.</p>
      <Link to="/" className="btn-emerald mt-8" data-testid="not-found-home-btn">Ana Sayfaya Dön</Link>
    </section>
  );
}
